import React from "react";
import { Typography } from "antd";
const { Text } = Typography;
export const MyText = ({
  text,
  children,
  type = "secondary",
  strong = false,
}) => {
  return (
    <Text type={type} strong={strong}>
      {text}
      {children}
    </Text>
  );
};
